import { ClientConfig } from 'client/configuration';
import { EdmundsAPI } from 'client/data/api/api-client';
import { LEASE, PURCHASE, DEALER_REVIEW_PARAM } from 'site-modules/shared/constants/car-buying';

/**
 * Creates short URL.
 * @param {string} url
 * @param {string} ttl - 7d or 30d
 * @return {JSON}
 */
export const getShortenUrl = ({ url, ttl }) => {
  const { apiDefaultTimeoutMs } = ClientConfig.get('carBuying');

  return EdmundsAPI.fetchJson('/car-buying/v2/short-url', {
    method: 'POST',
    body: JSON.stringify({ url, ttl }),
    headers: { 'Content-Type': 'application/json' },
    timeout: apiDefaultTimeoutMs,
  });
};

/**
 * Gets a short URL for my edmunds deal page.
 * @param {string} vin
 * @param {boolean} isPurchase
 * @param {boolean} isDealerPage
 * @param {string} dealParams
 * @returns {object}
 */
export const getFreeStandingReviewPageLink = async (vin, isPurchase, isDealerPage, dealParams) => {
  try {
    const type = isPurchase ? PURCHASE : LEASE;
    const dealerReview = isDealerPage ? `&${DEALER_REVIEW_PARAM}` : '';
    const url = `${window.location.origin}/digital-retail/my-edmunds-deal/${vin}/?${type}${dealerReview}&${dealParams}`;

    const { shortUrl } = await getShortenUrl({ url, ttl: '30d' });

    if (shortUrl) return { link: shortUrl };

    return { error: 'Could not retrieve URL' };
  } catch (error) {
    return {
      error,
    };
  }
};
